import { render, staticRenderFns } from "./actions-column.vue?vue&type=template&id=30ed8d7d&"
import script from "./actions-column.vue?vue&type=script&lang=js&"
export * from "./actions-column.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports